import { render, staticRenderFns } from "./MTP12Plug.vue?vue&type=template&id=7566174e"
import script from "./MTP12Plug.vue?vue&type=script&lang=js"
export * from "./MTP12Plug.vue?vue&type=script&lang=js"
import style0 from "./MTP12Plug.vue?vue&type=style&index=0&id=7566174e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports